export const ActionTypes = {
  LOADING: "GET_SUMMARY_LOADING",
  ERROR: "GET_SUMMARY_ERROR",
  SUCCESS: "GET_SUMMARY_SUCCESS",
};
